import {
    SET_DEFAULT_STATE,
    MESSAGE_HAS_SENT,
} from './constants';

import { IInitialState } from './interface';

/**
 * action to set initial state
 * @param topic
 * @param webchatPath
 * @param botName
 */
export const setDefaultState = (defaultState: IInitialState) => {
    return {
        type: SET_DEFAULT_STATE,
        defaultState,
    };
};

/**
 * call this action when a message from agent or bot has been sent,
 * this is needed, to show customer a loading animation for first interaction
 */
 export const messageFromAgentOrBotHasSent = () => {
    return {
        type: MESSAGE_HAS_SENT,
    };
};
